import { acceptHMRUpdate, defineStore } from "pinia"

export type Snackbar = {
  message: string
  color: string
  contentClass: string
  timeout: number
  visible: boolean
}

export type SnackbarOptions = Partial<Omit<Snackbar, "message" | "visible">>

export const useSnackbarsStore = defineStore("snackbars", {
  state: () => {
    return {
      snackbars: [] as Snackbar[],
    }
  },
  actions: {
    show(message: string, color: string, options: SnackbarOptions = {}): Snackbar {
      const snackbar: Snackbar = {
        message,
        color,
        contentClass: options.contentClass ?? "text-white",
        timeout: options.timeout ?? 5000,
        visible: true,
      }
      this.snackbars.push(snackbar)
      return snackbar
    },
    error(message: string, options: SnackbarOptions = {}): Snackbar {
      return this.show(message, "red", options)
    },
    success(message: string, options: SnackbarOptions = {}): Snackbar {
      return this.show(message, "green", options)
    },
    info(message: string, options: SnackbarOptions = {}): Snackbar {
      return this.show(message, "blue", options)
    },
    warning(message: string, options: SnackbarOptions = {}): Snackbar {
      return this.show(message, "orange", options)
    },
    hide(snackbar: Snackbar) {
      snackbar.visible = false
    },
  },
})

if (import.meta.hot) {
  // @ts-ignore
  import.meta.hot.accept(acceptHMRUpdate(useSnackbarsStore, import.meta.hot))
}
